'use client';

import { Paperclip } from 'lucide-react';
import { Button } from '../button/button';
import { useFileInput } from '@instamenu/react-hooks';

export const FileUpload = ({
  onFileSelect,
  disabled,
}: {
  onFileSelect: (base64: string) => void;
  disabled?: boolean;
}) => {
  const handleFileSelect = useFileInput(onFileSelect);

  const isFileUploadSupported = !!(
    window.File &&
    window.FileReader &&
    window.FileList &&
    window.Blob
  );

  if (!isFileUploadSupported) {
    return null;
  }

  return (
    <Button
      style={{
        width: 48,
        height: 48,
        borderRadius: 24,
        padding: 0,
        display: 'grid',
        placeItems: 'center',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
      as="label"
    >
      <Paperclip width={24} height={24} />
      <input
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        disabled={disabled}
        style={{ display: 'none' }}
      />
    </Button>
  );
};
